export class CategoryInfo{
    id :string = "";
    iconName:string = "";
    title:string = "";
    description:string = "";
    isDefault:boolean = false;
}